import React from "react";

const formStatus = {
    error: {
        message: "Oops! something went wrong while submitting the for. Please try again.",
        cssClass: "error"
    },
    success: {
        message:
            "Thank You! your submission has been received and we’ll be in touch shortly. Meanwhile, please setup a meeting by scheduling a call below. ",
        cssClass: "success"
    },
    idle: {
        message: "",
        cssClass: "idle"
    }
};

export type StatusType = "error" | "success" | "idle";

export default function FormStatus({ status, customMessage }: { status: StatusType , customMessage?: string}) {
    return (
        <div className={"status__message " + formStatus[status].cssClass}>
            <p>{customMessage ? customMessage : formStatus[status].message}</p>
        </div>
    );
}
